<template lang="html">
  <v-dialog
    scrollable
    :value="true"
    max-width="900"
    persistent
  >
    <v-form
      @submit.prevent="save"
      v-model="isValid"
      ref="form"
      style="width:100%"
    >
      <v-card :class="{large: !appSmall}">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          View Report
        </v-card-title>

        <v-card-text v-if="reports.length" class="pt-4">
          <SupervisorSummaryReport :reports="reports" ref="report" />
        </v-card-text>
        <v-card-text v-else class="pt-4">
          <div style="margin: 0 auto; max-width: 500px;">
            <v-text-field
              label="Report Name"
              value="Supervisor Summary"
              outlined
              disabled
              hide-details
              class="mb-3"
            ></v-text-field>
            <DateRangePicker
              outlined
              dialog
              v-model="dateRange"
            />
            <MachinesPicker
              class="mt-3"
              v-model="machinesSelected"
              multiple
              outlined
            />
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-alert :value="true" type="error" style="width:100%" v-if="error">{{error}}</v-alert>

        <v-card-actions>
          <v-btn
            v-if="!loading"
            @click="$emit('close')"
            text
          >
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-progress-circular
            v-if="loading || machinesLoading"
            class="ma-2"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!loading && reports.length"
            color="primary"
            text
            type="submit"
            @click="print"
          >
            Print
          </v-btn>
          <v-btn
            v-if="!loading && !reports.length"
            color="primary"
            text
            type="submit"
            @click="save"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<style lang="scss" scoped>
.large {
  .layout {
    .flex:first-child {
      padding-right: 8px;
    }
    .flex:last-child {
      padding-left: 8px;
    }
  }
}
</style>

<script>
import get from 'lodash/get'
import ValidationMixin from '@/mixins/ValidationMixin'
import DateRangePicker from '@/components/DateRangePicker'
import MachinesPicker from '@/components/MachinesPicker'
import moment from 'moment-timezone'
import axios from 'axios'
import { mapState, mapActions } from 'vuex'
import SupervisorSummaryReport from './SupervisorSummaryReport'

export default {
  mixins: [ValidationMixin],
  components: {
    DateRangePicker,
    MachinesPicker,
    SupervisorSummaryReport
  },
  data () {
    return {
      dateRange: null,
      machinesSelected: null,
      error: null,
      loading: false,
      reports: []
    }
  },
  computed: {
    ...mapState('machines', {
      machines: 'data',
      machinesLoading: 'loading'
    })
  },
  async created () {
    if (!this.machines.length) {
      await this.findMachines()
    }
  },
  methods: {
    ...mapActions('machines', {
      findMachines: 'find'
    }),
    print () {
      this.$refs.report.print()
      setTimeout(() => this.$emit('close'), 50)
    },
    async save () {
      if (!this.isValid) {
        this.$refs.form.validate()
        return
      }
      this.error = null
      if (this.loading) {
        return
      }
      this.loading = true
      try {
        let machineList = this.machinesSelected
        let reports = []
        for (var machineId of machineList) {
          let result = await axios({
            method: 'GET',
            url: '/rest/machine/' + machineId + '/data/totals',
            params: {
              fromDate: moment(this.dateRange.start).format('YYYY-MM-DD[T]HH:mm:ss'),
              toDate: moment(this.dateRange.end).format('YYYY-MM-DD[T]HH:mm:ss')
            }
          })
          reports.push({
            fromDate: this.dateRange.start,
            toDate: this.dateRange.end,
            date: moment().format('YYYY-MM-DD[T]HH:mm:ss'),
            machine: this.machines.find(m => m.id + '' === machineId),
            totals: result.data
          })
        }
        this.reports = reports
        this.loading = false
      } catch (e) {
        this.loading = false
        this.error = get(e, 'response.data') || e
        throw e
      }
    }
  }
}
</script>
